import jsPDF from "jspdf";
import "jspdf-autotable";

export const DownloadpdfDC = (title, columns, data) => {
    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.text(title, 10, 10);

    doc.autoTable({
        startY: 20, 
        head: [columns], 
        body: data, 
        styles: { fontSize: 12, cellPadding: 3 }, 
        theme: "grid", 
    });

    doc.save(`${title.replace(/\s+/g, "_")}.pdf`);
};
